const dateFormatterOptions: Intl.DateTimeFormatOptions = { month: 'short', day: '2-digit' }

interface FormatDateProps {
  timestamp: number
  options?: Intl.DateTimeFormatOptions
  showYear?: boolean
  showTime?: boolean
}

export const formatDate = ({ timestamp, options, showYear, showTime }: FormatDateProps) => {
  let displayYear = false

  if (showYear) {
    const timestampDate = new Date(timestamp)
    const now = new Date()
    displayYear = timestampDate.getFullYear() !== now.getFullYear()
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    ...dateFormatterOptions,
    ...(displayYear && { year: 'numeric' }),
    ...(showTime && { hour: '2-digit', minute: '2-digit' }),
    ...options,
  })
  return formatter.format(timestamp)
}
